// Dummy data generation utilities for menu and table data

// Sample bank names
const bankNames = [
  'Bank BCA', 'Bank Mandiri', 'Bank BRI', 'Bank BNI', 'Bank CIMB Niaga',
  'Bank Danamon', 'Bank Permata', 'Bank OCBC NISP', 'Bank Maybank', 'Bank BTN'
]

// Sample names
const sampleNames = [
  'PT TOLONG TRANSFER PAMAN RYAN', 'TOTO RUBIANTO', 'PT FAST TRANSFER', 'RUBIANTO SEJAHTERA',
  'PT TRANSFER CEPAT', 'BUDI TRANSFER', 'PT KIRIM UANG', 'SARI TRANSFER',
  'PT BAYAR MUDAH', 'TRANSFER NUSANTARA', 'PT UANG KILAT', 'KIRIM DANA',
  'PT TRANSFER AMAN', 'BAYAR ONLINE', 'PT KIRIM CEPAT'
]

// Generate random date in the past 30 days
const generateRandomDate = () => {
  const today = new Date()
  const pastDate = new Date(today.getTime() - Math.random() * 30 * 24 * 60 * 60 * 1000)
  return pastDate.toLocaleDateString('id-ID', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  })
}

// Generate random account number
const generateAccountNumber = () => {
  return Math.floor(Math.random() * 9000000000) + 1000000000
}

// Generate random amount between 10,000 and 100,000,000
const generateRandomAmount = () => {
  const amounts = [10000, 100000, 1000000, 10000000, 100000000]
  return amounts[Math.floor(Math.random() * amounts.length)]
}

// Get random item from array
const getRandomItem = (array) => {
  return array[Math.floor(Math.random() * array.length)]
}

// Generate single transaction record for general use
export const generateTransactionRecord = () => {
  const pengirim = getRandomItem(sampleNames)
  const penerima = getRandomItem(sampleNames)
  const randomId = Math.floor(Math.random() * 100000000)
  
  return {
    tanggal: generateRandomDate(),
    namaPengirim: pengirim,
    namaPenerima: penerima,
    keterangan: `BI FAST OUT ${penerima}${randomId}SLHBID${Math.floor(Math.random() * 1000000000)}`,
    tipe: 'BI FAST',
    nominal: generateRandomAmount(),
    biaya: 1500,
    tujuanBank: getRandomItem(bankNames),
    nomorRekening: generateAccountNumber().toString()
  }
}

// Generate DTTOT specific record
export const generateDTTOTRecord = () => {
  const pengirim = getRandomItem(sampleNames)
  const penerima = getRandomItem(sampleNames)
  
  return {
    tanggal: generateRandomDate(),
    namaPengirim: pengirim,
    namaPenerima: penerima,
    nominal: generateRandomAmount(),
    tujuanBank: getRandomItem(bankNames),
    nomorRekening: generateAccountNumber().toString()
  }
}

// Generate multiple transaction records
export const generateTransactionData = (count = 10) => {
  return Array.from({ length: count }, () => generateTransactionRecord())
}

// Generate DTTOT data
export const generateDTTOTData = (count = 10) => {
  return Array.from({ length: count }, () => generateDTTOTRecord())
}

// Menu items data structure
export const menuSections = [
  {
    id: 'menu-transaksi',
    title: 'Menu Transaksi',
    items: [
      { 
        id: 'rekap-transaksi',
        label: 'Rekap Transaksi', 
        description: null,
        type: 'menu'
      },
      { 
        id: 'data-transaksi',
        label: 'Data Transaksi', 
        description: 'Data yang dibuat based on tanggal',
        type: 'menu'
      },
      { 
        id: 'dttot',
        label: 'DTTOT', 
        description: 'cek dibawah format halamannya',
        type: 'table'
      },
      { 
        id: 'transaksi-khusus',
        label: 'Transaksi perhatian Khusus', 
        description: 'cek dibawah format halamannya',
        type: 'table'
      }
    ],
    isCollapsible: true,
    defaultExpanded: true
  },
  {
    id: 'menu-utama',
    title: 'Menu Utama',
    items: [
      { 
        id: 'rekap-xls',
        label: 'rekap transaksi xls', 
        description: null,
        type: 'menu'
      }
    ],
    isCollapsible: true,
    defaultExpanded: true
  }
]

// Table configurations
export const tableConfigs = {
  dttot: {
    title: 'MENU DTTOT',
    description: 'Data transaksi yang teridentifikasi dari list DTTOT',
    showSortDaily: true,
    columns: [
      { key: 'tanggal', title: 'Tanggal', align: 'left', sortable: true },
      { key: 'namaPengirim', title: 'Nama Pengirim', align: 'left', sortable: true },
      { key: 'namaPenerima', title: 'Nama Penerima', align: 'left', sortable: true },
      { key: 'nominal', title: 'Nominal', align: 'right', sortable: true },
      { key: 'tujuanBank', title: 'Tujuan Bank', align: 'left', sortable: true },
      { key: 'nomorRekening', title: 'Nomor Rekening', align: 'left', sortable: true }
    ]
  },
  transaksiKhusus: {
    title: 'Transaksi Perhatian Khusus',
    description: 'Data transaksi jam 00 - 05 pagi',
    showSortDaily: true,
    columns: [
      { key: 'tanggal', title: 'Tanggal', align: 'left', sortable: true },
      { key: 'namaPengirim', title: 'Nama Pengirim', align: 'left', sortable: true },
      { key: 'namaPenerima', title: 'Nama Penerima', align: 'left', sortable: true },
      { key: 'keterangan', title: 'Keterangan', align: 'left', sortable: false },
      { key: 'tipe', title: 'Tipe', align: 'left', sortable: true },
      { key: 'nominal', title: 'Nominal', align: 'right', sortable: true },
      { key: 'biaya', title: 'Biaya', align: 'right', sortable: true }
    ]
  }
}